(function ($) {
    if ($.validator) {
        $.validator.addMethod('oneoftworequired', function (value, element, params) {
            var elementName = $(element).attr('name');
            var dotPosition = elementName.lastIndexOf('.');
            var prefix = "";
            if (dotPosition !== -1) {
                prefix = elementName.substr(0, dotPosition + 1);
            }

            var dependentProperty = window[prefix + params.dependentproperty];

            // The property does not exist, so lets assume it is valid
            if (dependentProperty === undefined || dependentProperty === null) {
                return true;
            }
            var dependentPropertyVal = dependentProperty.GetValue();

            if (params.exclusiveor) {
                return (value !== null && dependentPropertyVal === null) ||
                       (value === null && dependentPropertyVal !== null);
            } else {
                return (value !== null || dependentPropertyVal !== null);
            }
        });

        $.validator.unobtrusive.adapters.add(
            'oneoftworequired',
            ['dependentproperty', 'exclusiveor'],
            function (options) {
                options.rules['oneoftworequired'] = options.params;
                options.messages['oneoftworequired'] = options.message;
            });

        $.validator.setDefaults({
            ignore: ":hidden"
        });


    }
})(jQuery);
